<p-dialog
	[visible]="visible"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
	[closable]="false"
	(onHide)="clearEmitter.emit(false)"
>
	<ng-template pTemplate="header">
		<div class="h3">Craft a new message</div>
	</ng-template>
	<div *ngIf="!premessage">
		<mat-stepper #msgStepper orientation="vertical" linear>
			<mat-step label="How do you want to send your message?" [stepControl]="messageTypeForm">
				<form [formGroup]="messageTypeForm">
					<mat-radio-group formControlName="type" class="d-flex flex-column mt-1">
						<mat-radio-button
							*ngFor="let method of notificationMethods"
							class="m-2"
							name="notifyType{{ method.value }}"
							[value]="method.value"
							[disabled]="method.disabled"
						>
							{{ method.label }}
						</mat-radio-button>
					</mat-radio-group>
				</form>
			</mat-step>
			<mat-step label="Who do you want to send to?" [stepControl]="messageSelectedEmployeesForm">
				<form [formGroup]="messageSelectedEmployeesForm">
					<p-multiSelect
						placeholder="Select Employee.."
						name="employeeListAvailable"
						[options]="employeeListAvailable"
						optionLabel="NickName"
						name="employeeList"
						[filter]="true"
						filterBy="LastName,FirstName,NickName,ID"
						[virtualScroll]="true"
						[virtualScrollItemSize]="31"
						formControlName="selectedEmployees"
						[style]="{ width: '100%' }"
						appendTo="body"
						styleClass="m-2"
					>
					</p-multiSelect>
				</form>
			</mat-step>
			<mat-step label="Build your message" [stepControl]="messagePropertiesForm">
				<form [formGroup]="messagePropertiesForm">
					<span class="p-float-label mt-4">
						<input pInputText type="text" id="subject" name="subject" formControlName="subject" class="w-100" />
						<label for="subject">Message Subject</label>
					</span>
					<span class="p-float-label mt-4">
						<textarea pInputTextarea class="w-100" formControlName="body" id="bod"></textarea>
						<label for="subject">Message Body</label>
					</span>
				</form>
			</mat-step>
		</mat-stepper>
	</div>
	<div *ngIf="premessage">
		<div class="d-flex flex-column">
			<div class="d-flex overflow-scroll m-2">
				<div *ngFor="let emp of premessageEmployeeNickNames" class="ms-1 text-nowrap">
					{{ emp }}
				</div>
			</div>
			<div class="m-2 h4">{{ premessage.subject }}</div>
			<div class="m-2">
				{{ premessage.body }}
			</div>
			<p-button pRipple styleClass="p-button-raised m-2" (click)="premessage = undefined; employeeRecordsSelected = []">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'undo']" size="lg" class="ms-1 me-2"></fa-icon>
						<div>Revise Message</div>
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			*ngIf="!premessage"
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="clearEmitter.emit(true)"
			(onSaveChange)="composeMessage()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="messagePropertiesForm.invalid"
			[saveLabel]="'Send'"
		></app-record-control-footer>
		<app-record-control-footer
			*ngIf="premessage"
			[hideAdd]="true"
			[hideDelete]="true"
			(onCancelChange)="clearEmitter.emit(true)"
			(onSaveChange)="createMessageAndSend()"
			[saveDisabled]="!premessage"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
